<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-row :gutter="24">
      <el-col :span="18">
        <div class="Yorumlar">
          <div class="Yorum" :class="y.Ai>0?'ai':''" v-for="y in Yorumlar">
            <div class="Icerik" v-html="y.Icerik"></div>
            <p class="Tarih">{{y.tarih}}</p>
            <p class="Kisi"> {{y.Kullanici}} <small>{{y.kMail}}</small></p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <BilgiKutu v-if="DestekBilgi" :data="DestekBilgi"></BilgiKutu>
        <a class=" btn-block text-center el-button--small el-button--success" @click="dialogVisible=true">Cevap Ver</a>
      </el-col>
    </el-row>
    <el-dialog
      title="Cevap Ver"
      :visible.sync="dialogVisible"
      width="50%">
      <el-select v-model="Durum">
        <el-option
          v-for="item in Turler"
          :key="item.id"
          :label="item.Adi"
          :value="item.id">
        </el-option>
      </el-select>
      <VueEditor v-model="Cevap"></VueEditor>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Kapat</el-button>
        <el-button type="primary" @click="CevapGonder">Onayla</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";
  import {VueEditor} from "vue2-editor"
  import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";

  export default {
    components: {BilgiKutu, Yukleniyor, VueEditor},
    props: ['id'],

    data() {
      return {
        Turler: [
          {id: '2', Adi: 'Aktif'},
          {id: '1', Adi: 'Yeni'},
          {id: '3', Adi: 'Pasif'},
          {id: '4', Adi: 'Takvim'},
          {id: '5', Adi: 'Cevap Bekleniyor'},
        ],
        Cevap: '',
        Durum: null,
        DestekBilgi: null,
        dialogVisible: false,
        customToolbar: [
          ["bold", "italic", "underline"],
          [{list: "ordered"}, {list: "bullet"}],
          ["image", "code-block"]
        ],
        lo: false
      }
    },
    methods: {
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: '_a/t/talep/' + this.id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Data = response.Data;
              this.Durum = this.Data.Durum;
              this.Yorumlar = response.Yorumlar;
              this.DestekBilgi = {
                Baslik: 'Talep Detay',
                Detay: [
                  {Baslik: 'Başlık', Bilgi: this.Data.Baslik},
                  {Baslik: 'Firma', Bilgi: this.Data.Unvan},
                  {Baslik: 'Tarih', Bilgi: this.Data.tarih},
                  {Baslik: 'Durum', Bilgi: this.Data.DurumText},
                ]
              };
            }
          });
      },
      CevapGonder() {
        this.lo = true;
        this.dialogVisible = false;
        this.$store.dispatch("Post", {Durum: this.Durum, Cevap: this.Cevap, id: this.id, path: '_a/t/cevap/'})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.lo = false;
              this.Cevap = '';

              this.SayfaYukle();
            } else {
              this.$message.error(response.Mesaj);
              this.lo = false;
            }
          })
      }
    },
    created() {
      this.SayfaYukle();
    },
    computed: {
      SayfaYenile() {
        return this.id
      },
    },
    watch: {
      SayfaYenile() {
        var oid = this.id;
        this.id = null;
        this.id = oid;
        this.SayfaYukle();
      },
    }
  }
</script>

<style scoped>
  h5.Baslik {
    padding-right: 100px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .SayfaYukle {
    position: absolute;
    right: 16px;
    top: 0px;
    z-index: 9;
  }

  .Yorumlar {
    height: 83vh;
    overflow: scroll;
  }

  .Yorum {
    padding: 10px;
    border-radius: 2px;
    border: 2px solid #ccc;
    margin-bottom: 40px;
    background: #f1f3f4;
    position: relative;
    margin-right: 120px;
  }

  .Yorum.ai {
    background: #f1f3f4;
    border-color: #3c7ae1;
    margin-left: 120px;
    margin-right: 0;

  }

  .Yorum.ai .Kisi {
    right: 0;
    left: inherit;
    text-align: right;
  }

  .Yorum.ai .Tarih {
    left: 0;
  }

  .Yorum .Icerik {
    font-size: 12px;
  }

  .Yorum .Tarih {
    font-size: 12px;
    right: 0;
    position: absolute;
    display: inline-block;
    margin: 0;
    bottom: -20px;
  }

  .Yorum .Kisi {
    font-size: 12px;
    left: 0;
    position: absolute;
    display: inline-block;
    margin: 0;
    bottom: -35px;
    text-align: left;
  }

  .Yorum .Kisi small {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/_a/comp/DestekDetay.vue